import { render, staticRenderFns } from "./CostumeNavBar.vue?vue&type=template&id=231967b9&"
import script from "./CostumeNavBar.vue?vue&type=script&lang=js&"
export * from "./CostumeNavBar.vue?vue&type=script&lang=js&"
import style0 from "./CostumeNavBar.vue?vue&type=style&index=0&id=231967b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports